/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The `DateTime` scalar represents an ISO-8601 compliant date time type. */
  DateTime: { input: any; output: any; }
  /** The `Long` scalar type represents non-fractional signed whole 64-bit numeric values. Long can represent values between -(2^63) and 2^63 - 1. */
  Long: { input: any; output: any; }
  UUID: { input: any; output: any; }
};

export type AccountAddress = {
  __typename?: 'AccountAddress';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
  line3?: Maybe<Scalars['String']['output']>;
  line4?: Maybe<Scalars['String']['output']>;
  line5?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
};

export type Accreditation = {
  __typename?: 'Accreditation';
  accreditationApplication?: Maybe<AccreditationApplication>;
  accreditationApplicationId?: Maybe<Scalars['UUID']['output']>;
  accreditationId: Scalars['UUID']['output'];
  accreditationType?: Maybe<AccreditationType>;
  accreditationTypeId: Scalars['UUID']['output'];
  awardedDate?: Maybe<Scalars['DateTime']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  member?: Maybe<Member>;
  memberId: Scalars['UUID']['output'];
  paymentCompleteDate?: Maybe<Scalars['DateTime']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
};

export type AccreditationApplication = {
  __typename?: 'AccreditationApplication';
  accreditationApplicationId: Scalars['UUID']['output'];
  accreditationType?: Maybe<AccreditationType>;
  accreditationTypeId: Scalars['UUID']['output'];
  applicationStatus: ApplicationStatus;
  billingRequestJson?: Maybe<Scalars['String']['output']>;
  hasMitigation: Scalars['Boolean']['output'];
  jsonData?: Maybe<Scalars['String']['output']>;
  lockedBy: LockOwner;
  member?: Maybe<Member>;
  memberId: Scalars['UUID']['output'];
  reviews?: Maybe<Array<Maybe<ApplicationReview>>>;
  updatedDate: Scalars['DateTime']['output'];
};

export type AccreditationApplicationItem = {
  __typename?: 'AccreditationApplicationItem';
  accreditationApplicationId: Scalars['UUID']['output'];
  accreditationType: AccreditationType;
  applicationStatus: ApplicationStatus;
  hasMitigation: Scalars['Boolean']['output'];
  isPaid: Scalars['Boolean']['output'];
  jsonData: Scalars['String']['output'];
  lockedBy: LockOwner;
  member: MemberItem;
  reviews: Array<ApplicationReviewSummaryItem>;
  updatedDate: Scalars['DateTime']['output'];
};

export type AccreditationApplicationPaymentCommandInput = {
  applicationId?: InputMaybe<Scalars['String']['input']>;
  redirectUri?: InputMaybe<Scalars['String']['input']>;
};

export type AccreditationApplicationPaymentCompleteCommandInput = {
  applicationId?: InputMaybe<Scalars['String']['input']>;
  billingRequestFlowJson?: InputMaybe<Scalars['String']['input']>;
  billingRequestJson?: InputMaybe<Scalars['String']['input']>;
  created: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type AccreditationType = {
  __typename?: 'AccreditationType';
  accreditationTypeId: Scalars['UUID']['output'];
  active: Scalars['Boolean']['output'];
  createdDate: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  price: Scalars['Float']['output'];
  requirementsJson?: Maybe<Scalars['String']['output']>;
  sortKey: Scalars['Int']['output'];
  supervisor: Scalars['Boolean']['output'];
};

export type AccreditationTypeInput = {
  accreditationTypeId: Scalars['UUID']['input'];
  active: Scalars['Boolean']['input'];
  createdDate: Scalars['DateTime']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['Float']['input'];
  requirementsJson?: InputMaybe<Scalars['String']['input']>;
  sortKey: Scalars['Int']['input'];
  supervisor: Scalars['Boolean']['input'];
};

export type Address = {
  __typename?: 'Address';
  addressId: Scalars['UUID']['output'];
  addressLine1: Scalars['String']['output'];
  addressLine2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  default: Scalars['Boolean']['output'];
  memberId: Scalars['UUID']['output'];
  postcode: Scalars['String']['output'];
  town?: Maybe<Scalars['String']['output']>;
};

export type ApplicationReview = {
  __typename?: 'ApplicationReview';
  accreditationApplication?: Maybe<AccreditationApplication>;
  accreditationApplicationId: Scalars['UUID']['output'];
  applicationReviewId: Scalars['UUID']['output'];
  isSubmitted: Scalars['Boolean']['output'];
  jsonData?: Maybe<Scalars['String']['output']>;
  requestedDate: Scalars['DateTime']['output'];
  reviewStatus: ReviewStatus;
  reviewer?: Maybe<Member>;
  reviewerId: Scalars['UUID']['output'];
  reviewerRole: ReviewerRole;
  updatedDate: Scalars['DateTime']['output'];
};

export type ApplicationReviewSummaryItem = {
  __typename?: 'ApplicationReviewSummaryItem';
  accreditationApplicationId: Scalars['UUID']['output'];
  accreditationType?: Maybe<AccreditationType>;
  applicant?: Maybe<MemberItem>;
  applicationReviewId: Scalars['UUID']['output'];
  requestedDate: Scalars['DateTime']['output'];
  reviewStatus: ReviewStatus;
  reviewer?: Maybe<MemberItem>;
  reviewerRole: ReviewerRole;
  updatedDate: Scalars['DateTime']['output'];
};

export enum ApplicationStatus {
  Approved = 'APPROVED',
  InProgress = 'IN_PROGRESS',
  NeedsWork = 'NEEDS_WORK',
  ReadyForReview = 'READY_FOR_REVIEW',
  ReadyToSubmit = 'READY_TO_SUBMIT',
  Rejected = 'REJECTED'
}

export enum ApplyPolicy {
  AfterResolver = 'AFTER_RESOLVER',
  BeforeResolver = 'BEFORE_RESOLVER',
  Validation = 'VALIDATION'
}

export type BillingRequestFlowRequest = {
  __typename?: 'BillingRequestFlowRequest';
  environment?: Maybe<Scalars['String']['output']>;
  flow_id?: Maybe<Scalars['String']['output']>;
};

export type BillingRequestFlowResponse = {
  __typename?: 'BillingRequestFlowResponse';
  error?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Broadcast = {
  __typename?: 'Broadcast';
  body: Scalars['String']['output'];
  broadcastId: Scalars['UUID']['output'];
  createdDate: Scalars['DateTime']['output'];
  event?: Maybe<Event>;
  eventId?: Maybe<Scalars['UUID']['output']>;
  recipients: Array<BroadcastRecipient>;
  segment?: Maybe<Segment>;
  segmentId?: Maybe<Scalars['UUID']['output']>;
  sentDate?: Maybe<Scalars['DateTime']['output']>;
  subject: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type BroadcastRecipient = {
  __typename?: 'BroadcastRecipient';
  broadcast: Broadcast;
  broadcastId: Scalars['UUID']['output'];
  broadcastRecipientId: Scalars['UUID']['output'];
  emailAddress: Scalars['String']['output'];
  failed: Scalars['Boolean']['output'];
  member: Member;
  memberId?: Maybe<Scalars['UUID']['output']>;
  readCount: Scalars['Int']['output'];
  sent: Scalars['Boolean']['output'];
};

export type CpdRequest = {
  __typename?: 'CPDRequest';
  id?: Maybe<Scalars['UUID']['output']>;
};

export type CpdScore = {
  __typename?: 'CPDScore';
  caScore: Scalars['Int']['output'];
  generalScore: Scalars['Int']['output'];
  percentile: Scalars['Int']['output'];
  score: Scalars['Int']['output'];
};

export type ChangeMemberUsernameCommandInput = {
  changedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  memberId: Scalars['UUID']['input'];
  username: Scalars['String']['input'];
};

export type CountryItem = {
  __typename?: 'CountryItem';
  countryId: Scalars['UUID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type CreateAccreditationApplicationCommandInput = {
  accreditationTypeId: Scalars['UUID']['input'];
};

export type CreateAddressCommandInput = {
  addressLine1: Scalars['String']['input'];
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  default: Scalars['Boolean']['input'];
  postcode: Scalars['String']['input'];
  town?: InputMaybe<Scalars['String']['input']>;
};

export type CreateMemberCommandInput = {
  advertisingOptIn: Scalars['Boolean']['input'];
  childTrainingLevel?: InputMaybe<Scalars['String']['input']>;
  childTrainingLevelDateAchieved?: InputMaybe<Scalars['DateTime']['input']>;
  declarationAgreed: Scalars['Boolean']['input'];
  defaultAddress?: InputMaybe<CreateAddressCommandInput>;
  defaultTelephone?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emdrTrainingLevel?: InputMaybe<MemberEmdrTrainingLevelInput>;
  emdrTrainingLevelDateAchieved?: InputMaybe<Scalars['DateTime']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  languages?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  membershipTypeId: Scalars['UUID']['input'];
  newsOptIn: Scalars['Boolean']['input'];
  professionalRegistrations?: InputMaybe<Array<InputMaybe<MemberProfessionalRegistrationInput>>>;
  professions?: InputMaybe<Array<InputMaybe<MemberProfessionInput>>>;
  qualifications?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<MemberRegionInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  userAccount?: InputMaybe<UserAccountInput>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerReference = {
  __typename?: 'CustomerReference';
  name?: Maybe<Scalars['String']['output']>;
  value: Scalars['Long']['output'];
};

export type DeleteAccreditationApplicationCommandInput = {
  accreditationApplicationId: Scalars['UUID']['input'];
};

export type DeleteDocumentCommandInput = {
  documentId: Scalars['UUID']['input'];
  eventId?: InputMaybe<Scalars['UUID']['input']>;
  memberId?: InputMaybe<Scalars['UUID']['input']>;
};

export type Document = {
  __typename?: 'Document';
  cpd?: Maybe<Scalars['Int']['output']>;
  cpdReceived?: Maybe<Scalars['Boolean']['output']>;
  cpdRejected?: Maybe<Scalars['Boolean']['output']>;
  cpdRequested?: Maybe<Scalars['Boolean']['output']>;
  createdBy: Scalars['UUID']['output'];
  createdDate: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  documentId: Scalars['UUID']['output'];
  eventId?: Maybe<Scalars['UUID']['output']>;
  expiries?: Maybe<Scalars['DateTime']['output']>;
  filename: Scalars['String']['output'];
  isCACPD?: Maybe<Scalars['Boolean']['output']>;
  lastModifiedBy?: Maybe<Scalars['UUID']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  member: Member;
  memberId?: Maybe<Scalars['UUID']['output']>;
  name: Scalars['String']['output'];
};

export type EmdrTrainingLevel = {
  __typename?: 'EMDRTrainingLevel';
  allowOnSignup: Scalars['Boolean']['output'];
  emdrTrainingLevelId: Scalars['UUID']['output'];
  isCA: Scalars['Boolean']['output'];
  isRegular: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  sortKey: Scalars['Int']['output'];
};

export type EmdrTrainingLevelItem = {
  __typename?: 'EMDRTrainingLevelItem';
  allowOnSignup: Scalars['Boolean']['output'];
  emdrTrainingLevelId: Scalars['UUID']['output'];
  isCA: Scalars['Boolean']['output'];
  isRegular: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Event = {
  __typename?: 'Event';
  cancelled: Scalars['Boolean']['output'];
  capacity?: Maybe<Scalars['Int']['output']>;
  certificateIssued: Scalars['Boolean']['output'];
  certificateTemplateHtml?: Maybe<Scalars['String']['output']>;
  childAndAdolescent: Scalars['Boolean']['output'];
  cpd: Scalars['Int']['output'];
  createdDate: Scalars['DateTime']['output'];
  documents?: Maybe<Array<Maybe<Document>>>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  eventHref?: Maybe<Scalars['String']['output']>;
  eventId: Scalars['UUID']['output'];
  eventPostHref?: Maybe<Scalars['String']['output']>;
  eventSurveyHref?: Maybe<Scalars['String']['output']>;
  expiryDate?: Maybe<Scalars['DateTime']['output']>;
  memberPrice: Scalars['Float']['output'];
  name?: Maybe<Scalars['String']['output']>;
  nonMemberPrice: Scalars['Float']['output'];
  participants?: Maybe<Array<Maybe<EventParticipant>>>;
  postId: Scalars['Long']['output'];
  soldOut: Scalars['Boolean']['output'];
  startDate: Scalars['DateTime']['output'];
  videos?: Maybe<Array<Maybe<Video>>>;
};

export type EventParticipant = {
  __typename?: 'EventParticipant';
  cancelled: Scalars['Boolean']['output'];
  certificateIssued?: Maybe<Scalars['DateTime']['output']>;
  createdDate: Scalars['DateTime']['output'];
  emailAddress: Scalars['String']['output'];
  event: Event;
  eventId: Scalars['UUID']['output'];
  eventParticipantId: Scalars['UUID']['output'];
  member?: Maybe<Member>;
  memberId?: Maybe<Scalars['UUID']['output']>;
  purchaseQuantity: Scalars['Int']['output'];
  purchaseResult: Scalars['String']['output'];
  surveyOpened?: Maybe<Scalars['DateTime']['output']>;
};

export type InvoiceLine = {
  __typename?: 'InvoiceLine';
  amount?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

export enum LockOwner {
  Applicant = 'APPLICANT',
  Emdr = 'EMDR',
  Supervisor = 'SUPERVISOR'
}

export enum MandateStatus {
  Active = 'ACTIVE',
  Blocked = 'BLOCKED',
  Cancelled = 'CANCELLED',
  Consumed = 'CONSUMED',
  Expired = 'EXPIRED',
  Failed = 'FAILED',
  PendingCustomerApproval = 'PENDING_CUSTOMER_APPROVAL',
  PendingSubmission = 'PENDING_SUBMISSION',
  Submitted = 'SUBMITTED',
  SuspendedByPayer = 'SUSPENDED_BY_PAYER',
  Unknown = 'UNKNOWN'
}

export type Member = {
  __typename?: 'Member';
  accreditationApplications: Array<AccreditationApplication>;
  accreditations: Array<Accreditation>;
  addresses: Array<Address>;
  advertisingOptIn: Scalars['Boolean']['output'];
  avatar?: Maybe<MemberAvatar>;
  broadcasts: Array<BroadcastRecipient>;
  childTrainingLevel?: Maybe<Scalars['String']['output']>;
  childTrainingLevelDateAchieved?: Maybe<Scalars['DateTime']['output']>;
  communicationPreferences: Array<MemberCommunicationPreferences>;
  customerId?: Maybe<Scalars['String']['output']>;
  dateArchived?: Maybe<Scalars['DateTime']['output']>;
  dateCreated: Scalars['DateTime']['output'];
  dateUpdated: Scalars['DateTime']['output'];
  declarationAgreed: Scalars['Boolean']['output'];
  documents: Array<Document>;
  email?: Maybe<Scalars['String']['output']>;
  emdrTrainingLevel: EmdrTrainingLevel;
  emdrTrainingLevelDateAchieved?: Maybe<Scalars['DateTime']['output']>;
  emdrTrainingLevelId?: Maybe<Scalars['UUID']['output']>;
  events: Array<EventParticipant>;
  firstname: Scalars['String']['output'];
  hasActiveMembership: Scalars['Boolean']['output'];
  languages?: Maybe<Scalars['String']['output']>;
  lastname: Scalars['String']['output'];
  memberId: Scalars['UUID']['output'];
  membershipNumber: Scalars['Long']['output'];
  memberships: Array<Membership>;
  newsOptIn: Scalars['Boolean']['output'];
  notes: Array<Note>;
  organisation?: Maybe<Scalars['String']['output']>;
  professionalRegistrations: Array<ProfessionalRegistration>;
  professions: Array<Profession>;
  qualifications?: Maybe<Scalars['String']['output']>;
  region: Region;
  regionId?: Maybe<Scalars['UUID']['output']>;
  telephones: Array<Telephone>;
  title?: Maybe<Scalars['String']['output']>;
  transactions: Array<Transaction>;
  userId?: Maybe<Scalars['UUID']['output']>;
  username?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type MemberAccount = {
  __typename?: 'MemberAccount';
  billingAddress?: Maybe<AccountAddress>;
  companyName?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
};

export type MemberAccreditation = {
  __typename?: 'MemberAccreditation';
  accreditationType?: Maybe<AccreditationType>;
  active: Scalars['Boolean']['output'];
  endDate?: Maybe<Scalars['DateTime']['output']>;
  expired: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  startDate?: Maybe<Scalars['DateTime']['output']>;
};

export type MemberAccreditationApplication = {
  __typename?: 'MemberAccreditationApplication';
  accreditationType?: Maybe<AccreditationType>;
  applicationStatus: ApplicationStatus;
  id?: Maybe<Scalars['UUID']['output']>;
  jsonData?: Maybe<Scalars['String']['output']>;
};

export type MemberAccreditationApplicationInput = {
  accreditationType?: InputMaybe<AccreditationTypeInput>;
  applicationStatus: ApplicationStatus;
  id?: InputMaybe<Scalars['UUID']['input']>;
  jsonData?: InputMaybe<Scalars['String']['input']>;
};

export type MemberAccreditationInput = {
  accreditationType?: InputMaybe<AccreditationTypeInput>;
  active: Scalars['Boolean']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  expired: Scalars['Boolean']['input'];
  id: Scalars['UUID']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MemberAvatar = {
  __typename?: 'MemberAvatar';
  data: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  member: Member;
  memberId: Scalars['UUID']['output'];
};

export type MemberCommunicationPreferenceDto = {
  __typename?: 'MemberCommunicationPreferenceDTO';
  enabled: Scalars['Boolean']['output'];
  memberId: Scalars['UUID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['UUID']['output']>;
};

export type MemberCommunicationPreferenceDtoInput = {
  enabled: Scalars['Boolean']['input'];
  memberId: Scalars['UUID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type MemberCommunicationPreferences = {
  __typename?: 'MemberCommunicationPreferences';
  communicationType: Scalars['String']['output'];
  createdBy: Scalars['UUID']['output'];
  createdDate: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  member: Member;
  memberId: Scalars['UUID']['output'];
  updatedBy?: Maybe<Scalars['UUID']['output']>;
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
};

export type MemberDocument = {
  __typename?: 'MemberDocument';
  cpd?: Maybe<Scalars['Int']['output']>;
  createdDate: Scalars['DateTime']['output'];
  expiries?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type MemberDocuments = {
  __typename?: 'MemberDocuments';
  documents?: Maybe<Array<MemberDocument>>;
  total: Scalars['Int']['output'];
  totalCPD?: Maybe<Scalars['Int']['output']>;
  totalDueToExpiry: Scalars['Int']['output'];
};

export type MemberEmdrTrainingLevelInput = {
  emdrTrainingLevelId: Scalars['UUID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type MemberEvent = {
  __typename?: 'MemberEvent';
  certificateIssued: Scalars['Boolean']['output'];
  documents?: Maybe<Array<MemberEventDocument>>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  eventId: Scalars['UUID']['output'];
  expiryDate?: Maybe<Scalars['DateTime']['output']>;
  href?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  memberCertificateIssued?: Maybe<Scalars['DateTime']['output']>;
  memberId?: Maybe<Scalars['UUID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  postHref?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['DateTime']['output'];
  surveyHref?: Maybe<Scalars['String']['output']>;
  surveyOpened?: Maybe<Scalars['DateTime']['output']>;
};

export type MemberEventDocument = {
  __typename?: 'MemberEventDocument';
  filename: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
};

export type MemberEvents = {
  __typename?: 'MemberEvents';
  events?: Maybe<Array<MemberEvent>>;
  total: Scalars['Int']['output'];
};

export type MemberInvoice = {
  __typename?: 'MemberInvoice';
  customerRef?: Maybe<CustomerReference>;
  docNumber?: Maybe<Scalars['String']['output']>;
  dueDate: Scalars['DateTime']['output'];
  id: Scalars['Long']['output'];
  line?: Maybe<Array<InvoiceLine>>;
};

export type MemberItem = {
  __typename?: 'MemberItem';
  email?: Maybe<Scalars['String']['output']>;
  memberId: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
};

export type MemberMembership = {
  __typename?: 'MemberMembership';
  active: Scalars['Boolean']['output'];
  customerId?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  initialPrice: Scalars['Float']['output'];
  mandateId?: Maybe<Scalars['String']['output']>;
  memberId: Scalars['UUID']['output'];
  membershipId: Scalars['UUID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  number: Scalars['Long']['output'];
  startDate?: Maybe<Scalars['DateTime']['output']>;
  subscriptionId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  yearlyPrice: Scalars['Float']['output'];
};

export type MemberProfessionInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  professionId: Scalars['UUID']['input'];
};

export type MemberProfessionalRegistrationInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  professionalRegistrationId: Scalars['UUID']['input'];
};

export type MemberProfile = {
  __typename?: 'MemberProfile';
  accreditationApplications?: Maybe<Array<Maybe<MemberAccreditationApplication>>>;
  activeAccreditations?: Maybe<Array<Maybe<MemberAccreditation>>>;
  address?: Maybe<MemberProfileAddress>;
  avatar?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emdrChildLevel?: Maybe<Scalars['String']['output']>;
  emdrChildLevelDate?: Maybe<Scalars['String']['output']>;
  emdrLevel?: Maybe<Scalars['String']['output']>;
  emdrLevelDate?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  membershipIsExpired?: Maybe<Scalars['Boolean']['output']>;
  membershipNumber?: Maybe<Scalars['Long']['output']>;
  membershipRenews?: Maybe<Scalars['DateTime']['output']>;
  membershipType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organisation?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  profession?: Maybe<Scalars['String']['output']>;
  professionalRegistration?: Maybe<Scalars['String']['output']>;
  qualifications?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type MemberProfileAddress = {
  __typename?: 'MemberProfileAddress';
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  regionId: Scalars['UUID']['output'];
};

export type MemberProfileAddressInput = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  regionId: Scalars['UUID']['input'];
};

export type MemberRegionInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  regionId: Scalars['UUID']['input'];
};

export type Membership = {
  __typename?: 'Membership';
  billingRequestJson: Scalars['String']['output'];
  endDate: Scalars['DateTime']['output'];
  mandateId: Scalars['String']['output'];
  memberId: Scalars['UUID']['output'];
  membershipId: Scalars['UUID']['output'];
  membershipNumber: Scalars['Long']['output'];
  membershipType: MembershipType;
  membershipTypeId: Scalars['UUID']['output'];
  startDate: Scalars['DateTime']['output'];
  subscriptionId: Scalars['String']['output'];
};

export type MembershipPaymentBypassCommandInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type MembershipPaymentCancelCommandInput = {
  mandateStatus?: InputMaybe<MandateStatus>;
  memberId?: InputMaybe<Scalars['String']['input']>;
  membershipId?: InputMaybe<Scalars['UUID']['input']>;
  subscriptionStatus?: InputMaybe<Scalars['String']['input']>;
};

export type MembershipPaymentCommandInput = {
  automaticRenewal: Scalars['Boolean']['input'];
  instantPayment: Scalars['Boolean']['input'];
  redirectUri?: InputMaybe<Scalars['String']['input']>;
  renewal: Scalars['Boolean']['input'];
};

export type MembershipPaymentCompleteCommandInput = {
  billingRequestFlowJson?: InputMaybe<Scalars['String']['input']>;
  billingRequestJson?: InputMaybe<Scalars['String']['input']>;
  created: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  mandateId?: InputMaybe<Scalars['String']['input']>;
  renew: Scalars['Boolean']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
  subscriptionId?: InputMaybe<Scalars['String']['input']>;
};

export type MembershipType = {
  __typename?: 'MembershipType';
  description: Scalars['String']['output'];
  initialPrice?: Maybe<Scalars['Float']['output']>;
  membershipTypeId: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  sortKey: Scalars['Int']['output'];
  yearlyPrice?: Maybe<Scalars['Float']['output']>;
};

export type MembershipTypeItem = {
  __typename?: 'MembershipTypeItem';
  description?: Maybe<Scalars['String']['output']>;
  membershipTypeId: Scalars['UUID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Create a new application. */
  accreditationApplicationCreate: AccreditationApplicationItem;
  /**
   * Delete application.
   *
   *
   * **Returns:**
   * The updated application object.
   */
  accreditationApplicationDelete: AccreditationApplicationItem;
  accreditationApplicationPayment: BillingRequestFlowRequest;
  accreditationApplicationPaymentResponse: BillingRequestFlowResponse;
  accreditationApplicationProgress: AccreditationApplicationItem;
  /**
   * Update application.
   *
   *
   * **Returns:**
   * The updated application object.
   */
  accreditationApplicationUpdate: AccreditationApplicationItem;
  /**
   * Update application.
   *
   *
   * **Returns:**
   * The updated application object.
   */
  applicationReviewUpdate: ApplicationReview;
  /**
   * Deletes a memebers document from the store.
   *
   *
   * **Returns:**
   * The members documents
   */
  deleteDocument: MemberDocuments;
  /**
   * Change a member's username.
   *
   *
   * **Returns:**
   * The updated member object.
   */
  memberChangeUsername: Member;
  /** Update a member's communication preferences. */
  memberCommunicationPreferences: Array<MemberCommunicationPreferenceDto>;
  /** Create a new member. */
  memberCreate: Member;
  /**
   * Initialises membership payment request.
   *
   *
   * **Returns:**
   * The billing request
   */
  membershipPayment: BillingRequestFlowRequest;
  membershipPaymentBypass: BillingRequestFlowResponse;
  membershipPaymentCancel: BillingRequestFlowResponse;
  /**
   * Updates membership based on payment response.
   *
   *
   * **Returns:**
   * The billing request response
   */
  membershipPaymentResponse: BillingRequestFlowResponse;
  profileUpdate: MemberProfile;
  requestCPD: CpdRequest;
  /** Updates a member's survey opened status. */
  surveyOpened: EventParticipant;
};


export type MutationAccreditationApplicationCreateArgs = {
  application?: InputMaybe<CreateAccreditationApplicationCommandInput>;
};


export type MutationAccreditationApplicationDeleteArgs = {
  application?: InputMaybe<DeleteAccreditationApplicationCommandInput>;
};


export type MutationAccreditationApplicationPaymentArgs = {
  command?: InputMaybe<AccreditationApplicationPaymentCommandInput>;
};


export type MutationAccreditationApplicationPaymentResponseArgs = {
  command: AccreditationApplicationPaymentCompleteCommandInput;
};


export type MutationAccreditationApplicationProgressArgs = {
  application?: InputMaybe<ProgressAccreditationApplicationCommandInput>;
};


export type MutationAccreditationApplicationUpdateArgs = {
  application?: InputMaybe<UpdateAccreditationApplicationCommandInput>;
};


export type MutationApplicationReviewUpdateArgs = {
  review?: InputMaybe<UpdateApplicationReviewCommandInput>;
};


export type MutationDeleteDocumentArgs = {
  command?: InputMaybe<DeleteDocumentCommandInput>;
};


export type MutationMemberChangeUsernameArgs = {
  command?: InputMaybe<ChangeMemberUsernameCommandInput>;
};


export type MutationMemberCommunicationPreferencesArgs = {
  command?: InputMaybe<UpdateMemberCommunicationPreferencesCommandInput>;
};


export type MutationMemberCreateArgs = {
  member?: InputMaybe<CreateMemberCommandInput>;
};


export type MutationMembershipPaymentArgs = {
  command?: InputMaybe<MembershipPaymentCommandInput>;
};


export type MutationMembershipPaymentBypassArgs = {
  command: MembershipPaymentBypassCommandInput;
};


export type MutationMembershipPaymentCancelArgs = {
  command: MembershipPaymentCancelCommandInput;
};


export type MutationMembershipPaymentResponseArgs = {
  command: MembershipPaymentCompleteCommandInput;
};


export type MutationProfileUpdateArgs = {
  profile?: InputMaybe<UpdateProfileCommandInput>;
};


export type MutationRequestCpdArgs = {
  command?: InputMaybe<RequestCpdCommandInput>;
};


export type MutationSurveyOpenedArgs = {
  command: UpdateEventParticipantCommandInput;
};

export type Note = {
  __typename?: 'Note';
  createdDate: Scalars['DateTime']['output'];
  member?: Maybe<Member>;
  memberId: Scalars['UUID']['output'];
  noteId: Scalars['UUID']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type Profession = {
  __typename?: 'Profession';
  members: Array<Member>;
  name: Scalars['String']['output'];
  professionId: Scalars['UUID']['output'];
  sortKey: Scalars['Int']['output'];
};

export type ProfessionItem = {
  __typename?: 'ProfessionItem';
  name?: Maybe<Scalars['String']['output']>;
  professionId: Scalars['UUID']['output'];
};

export type ProfessionalRegistration = {
  __typename?: 'ProfessionalRegistration';
  members: Array<Member>;
  name: Scalars['String']['output'];
  professionalRegistrationId: Scalars['UUID']['output'];
  sortKey: Scalars['Int']['output'];
};

export type ProfessionalRegistrationItem = {
  __typename?: 'ProfessionalRegistrationItem';
  name?: Maybe<Scalars['String']['output']>;
  professionalRegistrationId: Scalars['UUID']['output'];
};

export type ProgressAccreditationApplicationCommandInput = {
  accreditationApplicationId: Scalars['UUID']['input'];
  applicationStatus?: InputMaybe<ApplicationStatus>;
  nextLockOwner: LockOwner;
};

export type Query = {
  __typename?: 'Query';
  /**
   * Returns the accreditation application by Id.
   *
   *
   * **Returns:**
   * The requested accreditation application
   */
  accreditationApplication: AccreditationApplication;
  accreditationApplicationReview: ApplicationReview;
  accreditationApplicationReviewSummaries: Array<ApplicationReviewSummaryItem>;
  accreditationApplications: Array<AccreditationApplicationItem>;
  activeAccreditationTypes: Array<AccreditationType>;
  /**
   * Checks to see if a username is already in use.
   *
   *
   * **Returns:**
   * True if the username is already in use. requested member
   */
  checkUsername?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Returns the list of communication preferences for a member.
   *
   *
   * **Returns:**
   * The communication preference options.
   */
  communicationPreferences: Array<MemberCommunicationPreferenceDto>;
  /**
   * Returns the list of countries.
   *
   *
   * **Returns:**
   * The list of countries.
   */
  countries: Array<CountryItem>;
  cpdScore: CpdScore;
  documents: MemberDocuments;
  /**
   * Returns the list of available EMDR Training Levels.
   *
   *
   * **Returns:**
   * The list of EMDR training levels.
   */
  emdrTrainingLevels: Array<EmdrTrainingLevelItem>;
  /**
   * Returns the event by Id.
   *
   *
   * **Returns:**
   * The requested event
   */
  eventByPostId?: Maybe<Event>;
  /**
   * Returns the event by Id.
   *
   *
   * **Returns:**
   * The requested event
   */
  eventVideos: Array<Video>;
  events: MemberEvents;
  memberAccount: MemberAccount;
  memberAccreditations: Array<MemberAccreditation>;
  memberInvoiceHistory?: Maybe<Array<MemberInvoice>>;
  /**
   * Returns a collection of members filter by name.
   *
   *
   * **Returns:**
   * The collection of members.
   */
  members: Array<MemberItem>;
  membership: MemberMembership;
  /**
   * Returns the list of membership types.
   *
   *
   * **Returns:**
   * The list of membership types.
   */
  membershipTypes: Array<MembershipTypeItem>;
  /**
   * Returns a list of available professions registrations.
   *
   *
   * **Returns:**
   * The list of profession registrations.
   */
  professionalRegistrations: Array<ProfessionalRegistrationItem>;
  /**
   * Returns a list of available professions.
   *
   *
   * **Returns:**
   * The list of professions.
   */
  professions: Array<ProfessionItem>;
  profile: MemberProfile;
  /**
   * Returns the list of available regions.
   *
   *
   * **Returns:**
   * The list of regions.
   */
  regions: Array<RegionItem>;
  /**
   * Gets username for a userID
   *
   *
   * **Returns:**
   * True if the username is already in use. requested member
   */
  username: Scalars['String']['output'];
};


export type QueryAccreditationApplicationArgs = {
  applicationId: Scalars['UUID']['input'];
};


export type QueryAccreditationApplicationReviewArgs = {
  reviewId: Scalars['String']['input'];
};


export type QueryCheckUsernameArgs = {
  username: Scalars['String']['input'];
};


export type QueryCommunicationPreferencesArgs = {
  memberId: Scalars['UUID']['input'];
};


export type QueryEventByPostIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryEventVideosArgs = {
  id: Scalars['String']['input'];
};


export type QueryMembersArgs = {
  nameFilter: Scalars['String']['input'];
  supervisorsOnly?: Scalars['Boolean']['input'];
};


export type QueryUsernameArgs = {
  userId: Scalars['String']['input'];
};

export type Region = {
  __typename?: 'Region';
  name: Scalars['String']['output'];
  regionId: Scalars['UUID']['output'];
  sortKey: Scalars['Int']['output'];
};

export type RegionItem = {
  __typename?: 'RegionItem';
  name?: Maybe<Scalars['String']['output']>;
  regionId: Scalars['UUID']['output'];
};

export type RequestCpdCommandInput = {
  ca: Scalars['Boolean']['input'];
  cpd: Scalars['Int']['input'];
  memberId?: InputMaybe<Scalars['UUID']['input']>;
  primaryDocument: Scalars['UUID']['input'];
  reasonForRequest?: InputMaybe<Scalars['String']['input']>;
  supportingDocuments?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export enum ReviewStatus {
  Complete = 'COMPLETE',
  InProgress = 'IN_PROGRESS',
  NeedsWork = 'NEEDS_WORK'
}

export enum ReviewerRole {
  Emdr = 'EMDR',
  PrimarySupervisor = 'PRIMARY_SUPERVISOR',
  SecondarySupervisor = 'SECONDARY_SUPERVISOR'
}

export type Segment = {
  __typename?: 'Segment';
  conditionsJson: Scalars['String']['output'];
  createdDate: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  removedDate?: Maybe<Scalars['DateTime']['output']>;
  segmentId: Scalars['UUID']['output'];
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
};

export type Telephone = {
  __typename?: 'Telephone';
  default: Scalars['Boolean']['output'];
  memberId: Scalars['UUID']['output'];
  number: Scalars['String']['output'];
  telephoneId: Scalars['UUID']['output'];
};

export type Transaction = {
  __typename?: 'Transaction';
  createdDate: Scalars['DateTime']['output'];
  customerId?: Maybe<Scalars['String']['output']>;
  eventId?: Maybe<Scalars['String']['output']>;
  jsonData?: Maybe<Scalars['String']['output']>;
  memberId: Scalars['UUID']['output'];
  transactionId: Scalars['UUID']['output'];
};

export type UpdateAccreditationApplicationCommandInput = {
  accreditationApplicationId: Scalars['UUID']['input'];
  applicationStatus?: InputMaybe<ApplicationStatus>;
  hasMitigation?: InputMaybe<Scalars['Boolean']['input']>;
  jsonData?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type UpdateApplicationReviewCommandInput = {
  applicationReviewId: Scalars['UUID']['input'];
  jsonData?: InputMaybe<Scalars['String']['input']>;
  status: ReviewStatus;
};

export type UpdateEventParticipantCommandInput = {
  eventId?: InputMaybe<Scalars['String']['input']>;
  eventParticipantId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMemberCommunicationPreferencesCommandInput = {
  communicationPreferences?: InputMaybe<Array<InputMaybe<MemberCommunicationPreferenceDtoInput>>>;
  memberId: Scalars['UUID']['input'];
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type UpdateProfileCommandInput = {
  accreditationApplications?: InputMaybe<Array<InputMaybe<MemberAccreditationApplicationInput>>>;
  activeAccreditations?: InputMaybe<Array<InputMaybe<MemberAccreditationInput>>>;
  address?: InputMaybe<MemberProfileAddressInput>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emdrChildLevel?: InputMaybe<Scalars['String']['input']>;
  emdrChildLevelDate?: InputMaybe<Scalars['String']['input']>;
  emdrLevel?: InputMaybe<Scalars['String']['input']>;
  emdrLevelDate?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  membershipIsExpired?: InputMaybe<Scalars['Boolean']['input']>;
  membershipNumber?: InputMaybe<Scalars['Long']['input']>;
  membershipRenews?: InputMaybe<Scalars['DateTime']['input']>;
  membershipType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisation?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  profession?: InputMaybe<Scalars['String']['input']>;
  professionalRegistration?: InputMaybe<Scalars['String']['input']>;
  qualifications?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type UserAccountInput = {
  password?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type Video = {
  __typename?: 'Video';
  description?: Maybe<Scalars['String']['output']>;
  event: Event;
  eventId: Scalars['UUID']['output'];
  filename: Scalars['String']['output'];
  name: Scalars['String']['output'];
  videoId: Scalars['UUID']['output'];
};

export type GetAccountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAccountQuery = { __typename?: 'Query', memberAccount: { __typename?: 'MemberAccount', id: number, displayName?: string | null, companyName?: string | null, billingAddress?: { __typename?: 'AccountAddress', id?: string | null, line1?: string | null, line2?: string | null, line3?: string | null, line4?: string | null, line5?: string | null, city?: string | null, country?: string | null, countryCode?: string | null, county?: string | null, postcode?: string | null } | null } };

export type GetInvoiceHistoryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInvoiceHistoryQuery = { __typename?: 'Query', memberInvoiceHistory?: Array<{ __typename?: 'MemberInvoice', id: any, docNumber?: string | null, dueDate: any, line?: Array<{ __typename?: 'InvoiceLine', description?: string | null, amount?: number | null }> | null }> | null };

export type DeleteDocumentMutationVariables = Exact<{
  command: DeleteDocumentCommandInput;
}>;


export type DeleteDocumentMutation = { __typename?: 'Mutation', deleteDocument: { __typename?: 'MemberDocuments', total: number, totalCPD?: number | null, documents?: Array<{ __typename?: 'MemberDocument', id: any, name?: string | null, cpd?: number | null, expiries?: any | null }> | null } };

export type RequestCpdMutationVariables = Exact<{
  command: RequestCpdCommandInput;
}>;


export type RequestCpdMutation = { __typename?: 'Mutation', requestCPD: { __typename?: 'CPDRequest', id?: any | null } };

export type SurveyOpenedMutationMutationVariables = Exact<{
  command: UpdateEventParticipantCommandInput;
}>;


export type SurveyOpenedMutationMutation = { __typename?: 'Mutation', surveyOpened: { __typename?: 'EventParticipant', surveyOpened?: any | null } };

export type MemberCreateMutationMutationVariables = Exact<{
  member?: InputMaybe<CreateMemberCommandInput>;
}>;


export type MemberCreateMutationMutation = { __typename?: 'Mutation', memberCreate: { __typename?: 'Member', memberId: any, title?: string | null, firstname: string, lastname: string, email?: string | null, website?: string | null, qualifications?: string | null, childTrainingLevel?: string | null, childTrainingLevelDateAchieved?: any | null, region: { __typename?: 'Region', regionId: any, name: string }, addresses: Array<{ __typename?: 'Address', addressId: any, addressLine1: string, addressLine2?: string | null }>, professions: Array<{ __typename?: 'Profession', professionId: any, name: string }>, professionalRegistrations: Array<{ __typename?: 'ProfessionalRegistration', professionalRegistrationId: any, name: string }> } };

export type MemberCommunicationPreferencesMutationMutationVariables = Exact<{
  command?: InputMaybe<UpdateMemberCommunicationPreferencesCommandInput>;
}>;


export type MemberCommunicationPreferencesMutationMutation = { __typename?: 'Mutation', memberCommunicationPreferences: Array<{ __typename?: 'MemberCommunicationPreferenceDTO', memberId: any, name?: string | null, enabled: boolean }> };

export type ApplicationCreateMutationMutationVariables = Exact<{
  application?: InputMaybe<CreateAccreditationApplicationCommandInput>;
}>;


export type ApplicationCreateMutationMutation = { __typename?: 'Mutation', accreditationApplicationCreate: { __typename?: 'AccreditationApplicationItem', accreditationApplicationId: any, applicationStatus: ApplicationStatus, jsonData: string, accreditationType: { __typename?: 'AccreditationType', accreditationTypeId: any, name?: string | null, price: number, requirementsJson?: string | null } } };

export type ApplicationProgressMutationMutationVariables = Exact<{
  application?: InputMaybe<ProgressAccreditationApplicationCommandInput>;
}>;


export type ApplicationProgressMutationMutation = { __typename?: 'Mutation', accreditationApplicationProgress: { __typename?: 'AccreditationApplicationItem', accreditationApplicationId: any, applicationStatus: ApplicationStatus, lockedBy: LockOwner, updatedDate: any, reviews: Array<{ __typename?: 'ApplicationReviewSummaryItem', applicationReviewId: any, reviewerRole: ReviewerRole, reviewStatus: ReviewStatus, updatedDate: any, reviewer?: { __typename?: 'MemberItem', name: string, memberId: any } | null, applicant?: { __typename?: 'MemberItem', name: string } | null }>, accreditationType: { __typename?: 'AccreditationType', accreditationTypeId: any, name?: string | null, price: number, requirementsJson?: string | null } } };

export type ApplicationUpdateMutationMutationVariables = Exact<{
  application?: InputMaybe<UpdateAccreditationApplicationCommandInput>;
}>;


export type ApplicationUpdateMutationMutation = { __typename?: 'Mutation', accreditationApplicationUpdate: { __typename?: 'AccreditationApplicationItem', accreditationApplicationId: any, applicationStatus: ApplicationStatus, jsonData: string, isPaid: boolean, hasMitigation: boolean, accreditationType: { __typename?: 'AccreditationType', accreditationTypeId: any, name?: string | null, price: number, requirementsJson?: string | null } } };

export type DeleteApplicationMutationMutationVariables = Exact<{
  application?: InputMaybe<DeleteAccreditationApplicationCommandInput>;
}>;


export type DeleteApplicationMutationMutation = { __typename?: 'Mutation', accreditationApplicationDelete: { __typename?: 'AccreditationApplicationItem', accreditationApplicationId: any } };

export type ApplicationReviewUpdateMutationMutationVariables = Exact<{
  review?: InputMaybe<UpdateApplicationReviewCommandInput>;
}>;


export type ApplicationReviewUpdateMutationMutation = { __typename?: 'Mutation', applicationReviewUpdate: { __typename?: 'ApplicationReview', applicationReviewId: any, jsonData?: string | null, reviewStatus: ReviewStatus } };

export type ChangeUsernameMutationVariables = Exact<{
  memberId: Scalars['UUID']['input'];
  username: Scalars['String']['input'];
}>;


export type ChangeUsernameMutation = { __typename?: 'Mutation', memberChangeUsername: { __typename?: 'Member', memberId: any, username?: string | null } };

export type GetAccreditationApplicationReviewSummariesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAccreditationApplicationReviewSummariesQuery = { __typename?: 'Query', accreditationApplicationReviewSummaries: Array<{ __typename?: 'ApplicationReviewSummaryItem', accreditationApplicationId: any, applicationReviewId: any, reviewerRole: ReviewerRole, requestedDate: any, updatedDate: any, reviewStatus: ReviewStatus, accreditationType?: { __typename?: 'AccreditationType', accreditationTypeId: any, name?: string | null } | null, applicant?: { __typename?: 'MemberItem', name: string, memberId: any } | null, reviewer?: { __typename?: 'MemberItem', memberId: any, name: string } | null }> };

export type GetAccreditationApplicationReviewQueryVariables = Exact<{
  reviewId: Scalars['String']['input'];
}>;


export type GetAccreditationApplicationReviewQuery = { __typename?: 'Query', accreditationApplicationReview: { __typename?: 'ApplicationReview', jsonData?: string | null, applicationReviewId: any, accreditationApplication?: { __typename?: 'AccreditationApplication', jsonData?: string | null, accreditationApplicationId: any, memberId: any, applicationStatus: ApplicationStatus, accreditationType?: { __typename?: 'AccreditationType', requirementsJson?: string | null, name?: string | null } | null } | null } };

export type CommunicationPreferencesQueryVariables = Exact<{
  memberId: Scalars['UUID']['input'];
}>;


export type CommunicationPreferencesQuery = { __typename?: 'Query', communicationPreferences: Array<{ __typename?: 'MemberCommunicationPreferenceDTO', memberId: any, name?: string | null, enabled: boolean }> };

export type CheckUsernameQueryVariables = Exact<{
  username: Scalars['String']['input'];
}>;


export type CheckUsernameQuery = { __typename?: 'Query', checkUsername?: boolean | null };

export type GetUsernameQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type GetUsernameQuery = { __typename?: 'Query', username: string };

export type GetMembersQueryVariables = Exact<{
  searchTerm: Scalars['String']['input'];
}>;


export type GetMembersQuery = { __typename?: 'Query', members: Array<{ __typename?: 'MemberItem', name: string, memberId: any }> };

export type GetSupervisorsQueryVariables = Exact<{
  searchTerm: Scalars['String']['input'];
}>;


export type GetSupervisorsQuery = { __typename?: 'Query', members: Array<{ __typename?: 'MemberItem', name: string, memberId: any, email?: string | null }> };

export type MembershipPaymentMutationVariables = Exact<{
  command: MembershipPaymentCommandInput;
}>;


export type MembershipPaymentMutation = { __typename?: 'Mutation', membershipPayment: { __typename?: 'BillingRequestFlowRequest', flow_id?: string | null, environment?: string | null } };

export type MembershipPaymentResponseMutationVariables = Exact<{
  command: MembershipPaymentCompleteCommandInput;
}>;


export type MembershipPaymentResponseMutation = { __typename?: 'Mutation', membershipPaymentResponse: { __typename?: 'BillingRequestFlowResponse', id?: string | null, success: boolean, error?: string | null } };

export type MembershipPaymentBypassMutationVariables = Exact<{
  command: MembershipPaymentBypassCommandInput;
}>;


export type MembershipPaymentBypassMutation = { __typename?: 'Mutation', membershipPaymentBypass: { __typename?: 'BillingRequestFlowResponse', id?: string | null, success: boolean, error?: string | null } };

export type MembershipPaymentCancelMutationVariables = Exact<{
  command: MembershipPaymentCancelCommandInput;
}>;


export type MembershipPaymentCancelMutation = { __typename?: 'Mutation', membershipPaymentCancel: { __typename?: 'BillingRequestFlowResponse', id?: string | null, success: boolean, error?: string | null } };

export type AccreditationApplicationPaymentMutationVariables = Exact<{
  command: AccreditationApplicationPaymentCommandInput;
}>;


export type AccreditationApplicationPaymentMutation = { __typename?: 'Mutation', accreditationApplicationPayment: { __typename?: 'BillingRequestFlowRequest', flow_id?: string | null, environment?: string | null } };

export type AccreditationApplicationPaymentResponseMutationVariables = Exact<{
  command: AccreditationApplicationPaymentCompleteCommandInput;
}>;


export type AccreditationApplicationPaymentResponseMutation = { __typename?: 'Mutation', accreditationApplicationPaymentResponse: { __typename?: 'BillingRequestFlowResponse', id?: string | null, success: boolean, error?: string | null } };

export type ProfileUpdateMutationMutationVariables = Exact<{
  profile?: InputMaybe<UpdateProfileCommandInput>;
}>;


export type ProfileUpdateMutationMutation = { __typename?: 'Mutation', profileUpdate: { __typename?: 'MemberProfile', id: any, email?: string | null, firstName?: string | null, lastName?: string | null, name?: string | null, organisation?: string | null, phone?: string | null, website?: string | null, avatar?: string | null, title?: string | null, address?: { __typename?: 'MemberProfileAddress', id?: any | null, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, country?: string | null, postcode?: string | null, regionId: any } | null } };

export type GetProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProfileQuery = { __typename?: 'Query', profile: { __typename?: 'MemberProfile', id: any, membershipNumber?: any | null, name?: string | null, title?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, organisation?: string | null, website?: string | null, avatar?: string | null, profession?: string | null, professionalRegistration?: string | null, emdrLevel?: string | null, emdrChildLevel?: string | null, emdrLevelDate?: string | null, emdrChildLevelDate?: string | null, qualifications?: string | null, membershipIsExpired?: boolean | null, address?: { __typename?: 'MemberProfileAddress', id?: any | null, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, country?: string | null, postcode?: string | null, region?: string | null, regionId: any } | null, accreditationApplications?: Array<{ __typename?: 'MemberAccreditationApplication', applicationStatus: ApplicationStatus, id?: any | null, accreditationType?: { __typename?: 'AccreditationType', name?: string | null, accreditationTypeId: any } | null } | null> | null, activeAccreditations?: Array<{ __typename?: 'MemberAccreditation', startDate?: any | null } | null> | null } };

export type GetMembershipQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMembershipQuery = { __typename?: 'Query', membership: { __typename?: 'MemberMembership', membershipId: any, memberId: any, number: any, type?: string | null, active: boolean, startDate?: any | null, endDate?: any | null, name?: string | null, subscriptionId?: string | null, mandateId?: string | null, yearlyPrice: number, initialPrice: number } };

export type GetMemberAccreditationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMemberAccreditationsQuery = { __typename?: 'Query', memberAccreditations: Array<{ __typename?: 'MemberAccreditation', id: any, active: boolean, expired: boolean, startDate?: any | null, endDate?: any | null, accreditationType?: { __typename?: 'AccreditationType', name?: string | null, description?: string | null, price: number, active: boolean, accreditationTypeId: any } | null }> };

export type GetDocumentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDocumentsQuery = { __typename?: 'Query', documents: { __typename?: 'MemberDocuments', total: number, totalCPD?: number | null, totalDueToExpiry: number, documents?: Array<{ __typename?: 'MemberDocument', id: any, name?: string | null, cpd?: number | null, expiries?: any | null }> | null } };

export type GetEventsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEventsQuery = { __typename?: 'Query', events: { __typename?: 'MemberEvents', total: number, events?: Array<{ __typename?: 'MemberEvent', id: any, eventId: any, memberId?: any | null, name?: string | null, href?: string | null, postHref?: string | null, surveyHref?: string | null, startDate: any, endDate?: any | null, expiryDate?: any | null, surveyOpened?: any | null, certificateIssued: boolean, memberCertificateIssued?: any | null, documents?: Array<{ __typename?: 'MemberEventDocument', id: any, name: string, filename: string }> | null }> | null } };

export type GetCpdScoreQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCpdScoreQuery = { __typename?: 'Query', cpdScore: { __typename?: 'CPDScore', generalScore: number, caScore: number, score: number, percentile: number } };


export const GetAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"memberAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"line3"}},{"kind":"Field","name":{"kind":"Name","value":"line4"}},{"kind":"Field","name":{"kind":"Name","value":"line5"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"county"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}}]}}]}}]}}]} as unknown as DocumentNode<GetAccountQuery, GetAccountQueryVariables>;
export const GetInvoiceHistoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetInvoiceHistory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"memberInvoiceHistory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"docNumber"}},{"kind":"Field","name":{"kind":"Name","value":"dueDate"}},{"kind":"Field","name":{"kind":"Name","value":"line"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}}]} as unknown as DocumentNode<GetInvoiceHistoryQuery, GetInvoiceHistoryQueryVariables>;
export const DeleteDocumentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteDocument"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"command"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteDocumentCommandInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteDocument"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"command"},"value":{"kind":"Variable","name":{"kind":"Name","value":"command"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"totalCPD"}},{"kind":"Field","name":{"kind":"Name","value":"documents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"cpd"}},{"kind":"Field","name":{"kind":"Name","value":"expiries"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteDocumentMutation, DeleteDocumentMutationVariables>;
export const RequestCpdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"requestCPD"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"command"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RequestCPDCommandInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requestCPD"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"command"},"value":{"kind":"Variable","name":{"kind":"Name","value":"command"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RequestCpdMutation, RequestCpdMutationVariables>;
export const SurveyOpenedMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"surveyOpenedMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"command"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateEventParticipantCommandInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"surveyOpened"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"command"},"value":{"kind":"Variable","name":{"kind":"Name","value":"command"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"surveyOpened"}}]}}]}}]} as unknown as DocumentNode<SurveyOpenedMutationMutation, SurveyOpenedMutationMutationVariables>;
export const MemberCreateMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"memberCreateMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"member"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateMemberCommandInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"memberCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"member"},"value":{"kind":"Variable","name":{"kind":"Name","value":"member"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"memberId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"qualifications"}},{"kind":"Field","name":{"kind":"Name","value":"childTrainingLevel"}},{"kind":"Field","name":{"kind":"Name","value":"childTrainingLevelDateAchieved"}},{"kind":"Field","name":{"kind":"Name","value":"region"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"regionId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"addresses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressId"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine1"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}}]}},{"kind":"Field","name":{"kind":"Name","value":"professions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"professionId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"professionalRegistrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"professionalRegistrationId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<MemberCreateMutationMutation, MemberCreateMutationMutationVariables>;
export const MemberCommunicationPreferencesMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"memberCommunicationPreferencesMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"command"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateMemberCommunicationPreferencesCommandInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"memberCommunicationPreferences"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"command"},"value":{"kind":"Variable","name":{"kind":"Name","value":"command"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"memberId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}}]}}]} as unknown as DocumentNode<MemberCommunicationPreferencesMutationMutation, MemberCommunicationPreferencesMutationMutationVariables>;
export const ApplicationCreateMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"applicationCreateMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"application"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateAccreditationApplicationCommandInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accreditationApplicationCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"application"},"value":{"kind":"Variable","name":{"kind":"Name","value":"application"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accreditationApplicationId"}},{"kind":"Field","name":{"kind":"Name","value":"applicationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"jsonData"}},{"kind":"Field","name":{"kind":"Name","value":"accreditationType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accreditationTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"requirementsJson"}}]}}]}}]}}]} as unknown as DocumentNode<ApplicationCreateMutationMutation, ApplicationCreateMutationMutationVariables>;
export const ApplicationProgressMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"applicationProgressMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"application"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProgressAccreditationApplicationCommandInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accreditationApplicationProgress"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"application"},"value":{"kind":"Variable","name":{"kind":"Name","value":"application"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accreditationApplicationId"}},{"kind":"Field","name":{"kind":"Name","value":"applicationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"lockedBy"}},{"kind":"Field","name":{"kind":"Name","value":"updatedDate"}},{"kind":"Field","name":{"kind":"Name","value":"reviews"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"applicationReviewId"}},{"kind":"Field","name":{"kind":"Name","value":"reviewerRole"}},{"kind":"Field","name":{"kind":"Name","value":"reviewStatus"}},{"kind":"Field","name":{"kind":"Name","value":"updatedDate"}},{"kind":"Field","name":{"kind":"Name","value":"reviewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"memberId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"applicant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"accreditationType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accreditationTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"requirementsJson"}}]}}]}}]}}]} as unknown as DocumentNode<ApplicationProgressMutationMutation, ApplicationProgressMutationMutationVariables>;
export const ApplicationUpdateMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"applicationUpdateMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"application"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateAccreditationApplicationCommandInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accreditationApplicationUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"application"},"value":{"kind":"Variable","name":{"kind":"Name","value":"application"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accreditationApplicationId"}},{"kind":"Field","name":{"kind":"Name","value":"applicationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"jsonData"}},{"kind":"Field","name":{"kind":"Name","value":"isPaid"}},{"kind":"Field","name":{"kind":"Name","value":"accreditationType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accreditationTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"requirementsJson"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasMitigation"}}]}}]}}]} as unknown as DocumentNode<ApplicationUpdateMutationMutation, ApplicationUpdateMutationMutationVariables>;
export const DeleteApplicationMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteApplicationMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"application"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteAccreditationApplicationCommandInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accreditationApplicationDelete"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"application"},"value":{"kind":"Variable","name":{"kind":"Name","value":"application"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accreditationApplicationId"}}]}}]}}]} as unknown as DocumentNode<DeleteApplicationMutationMutation, DeleteApplicationMutationMutationVariables>;
export const ApplicationReviewUpdateMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"applicationReviewUpdateMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"review"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateApplicationReviewCommandInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"applicationReviewUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"review"},"value":{"kind":"Variable","name":{"kind":"Name","value":"review"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"applicationReviewId"}},{"kind":"Field","name":{"kind":"Name","value":"jsonData"}},{"kind":"Field","name":{"kind":"Name","value":"reviewStatus"}}]}}]}}]} as unknown as DocumentNode<ApplicationReviewUpdateMutationMutation, ApplicationReviewUpdateMutationMutationVariables>;
export const ChangeUsernameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ChangeUsername"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"username"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"memberChangeUsername"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"command"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"memberId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"username"},"value":{"kind":"Variable","name":{"kind":"Name","value":"username"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"memberId"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}}]}}]} as unknown as DocumentNode<ChangeUsernameMutation, ChangeUsernameMutationVariables>;
export const GetAccreditationApplicationReviewSummariesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAccreditationApplicationReviewSummaries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accreditationApplicationReviewSummaries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accreditationApplicationId"}},{"kind":"Field","name":{"kind":"Name","value":"accreditationType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accreditationTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"applicant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"memberId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reviewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"memberId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"applicationReviewId"}},{"kind":"Field","name":{"kind":"Name","value":"reviewerRole"}},{"kind":"Field","name":{"kind":"Name","value":"requestedDate"}},{"kind":"Field","name":{"kind":"Name","value":"updatedDate"}},{"kind":"Field","name":{"kind":"Name","value":"reviewStatus"}}]}}]}}]} as unknown as DocumentNode<GetAccreditationApplicationReviewSummariesQuery, GetAccreditationApplicationReviewSummariesQueryVariables>;
export const GetAccreditationApplicationReviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAccreditationApplicationReview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reviewId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accreditationApplicationReview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"reviewId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reviewId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accreditationApplication"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jsonData"}},{"kind":"Field","name":{"kind":"Name","value":"accreditationApplicationId"}},{"kind":"Field","name":{"kind":"Name","value":"memberId"}},{"kind":"Field","name":{"kind":"Name","value":"accreditationType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requirementsJson"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"applicationStatus"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jsonData"}},{"kind":"Field","name":{"kind":"Name","value":"applicationReviewId"}}]}}]}}]} as unknown as DocumentNode<GetAccreditationApplicationReviewQuery, GetAccreditationApplicationReviewQueryVariables>;
export const CommunicationPreferencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CommunicationPreferences"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"communicationPreferences"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"memberId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"memberId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}}]}}]} as unknown as DocumentNode<CommunicationPreferencesQuery, CommunicationPreferencesQueryVariables>;
export const CheckUsernameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CheckUsername"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"username"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkUsername"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"username"},"value":{"kind":"Variable","name":{"kind":"Name","value":"username"}}}]}]}}]} as unknown as DocumentNode<CheckUsernameQuery, CheckUsernameQueryVariables>;
export const GetUsernameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUsername"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"username"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}]}}]} as unknown as DocumentNode<GetUsernameQuery, GetUsernameQueryVariables>;
export const GetMembersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMembers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchTerm"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"members"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"nameFilter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchTerm"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"memberId"}}]}}]}}]} as unknown as DocumentNode<GetMembersQuery, GetMembersQueryVariables>;
export const GetSupervisorsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSupervisors"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchTerm"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"members"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"nameFilter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchTerm"}}},{"kind":"Argument","name":{"kind":"Name","value":"supervisorsOnly"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"memberId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<GetSupervisorsQuery, GetSupervisorsQueryVariables>;
export const MembershipPaymentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"membershipPayment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"command"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MembershipPaymentCommandInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"membershipPayment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"command"},"value":{"kind":"Variable","name":{"kind":"Name","value":"command"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flow_id"}},{"kind":"Field","name":{"kind":"Name","value":"environment"}}]}}]}}]} as unknown as DocumentNode<MembershipPaymentMutation, MembershipPaymentMutationVariables>;
export const MembershipPaymentResponseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"membershipPaymentResponse"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"command"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MembershipPaymentCompleteCommandInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"membershipPaymentResponse"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"command"},"value":{"kind":"Variable","name":{"kind":"Name","value":"command"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]} as unknown as DocumentNode<MembershipPaymentResponseMutation, MembershipPaymentResponseMutationVariables>;
export const MembershipPaymentBypassDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"membershipPaymentBypass"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"command"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MembershipPaymentBypassCommandInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"membershipPaymentBypass"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"command"},"value":{"kind":"Variable","name":{"kind":"Name","value":"command"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]} as unknown as DocumentNode<MembershipPaymentBypassMutation, MembershipPaymentBypassMutationVariables>;
export const MembershipPaymentCancelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"membershipPaymentCancel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"command"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MembershipPaymentCancelCommandInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"membershipPaymentCancel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"command"},"value":{"kind":"Variable","name":{"kind":"Name","value":"command"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]} as unknown as DocumentNode<MembershipPaymentCancelMutation, MembershipPaymentCancelMutationVariables>;
export const AccreditationApplicationPaymentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"accreditationApplicationPayment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"command"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccreditationApplicationPaymentCommandInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accreditationApplicationPayment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"command"},"value":{"kind":"Variable","name":{"kind":"Name","value":"command"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flow_id"}},{"kind":"Field","name":{"kind":"Name","value":"environment"}}]}}]}}]} as unknown as DocumentNode<AccreditationApplicationPaymentMutation, AccreditationApplicationPaymentMutationVariables>;
export const AccreditationApplicationPaymentResponseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"accreditationApplicationPaymentResponse"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"command"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccreditationApplicationPaymentCompleteCommandInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accreditationApplicationPaymentResponse"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"command"},"value":{"kind":"Variable","name":{"kind":"Name","value":"command"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]} as unknown as DocumentNode<AccreditationApplicationPaymentResponseMutation, AccreditationApplicationPaymentResponseMutationVariables>;
export const ProfileUpdateMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"profileUpdateMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"profile"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProfileCommandInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profileUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"profile"},"value":{"kind":"Variable","name":{"kind":"Name","value":"profile"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine1"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"regionId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"organisation"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<ProfileUpdateMutationMutation, ProfileUpdateMutationMutationVariables>;
export const GetProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"membershipNumber"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"organisation"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"profession"}},{"kind":"Field","name":{"kind":"Name","value":"professionalRegistration"}},{"kind":"Field","name":{"kind":"Name","value":"emdrLevel"}},{"kind":"Field","name":{"kind":"Name","value":"emdrChildLevel"}},{"kind":"Field","name":{"kind":"Name","value":"emdrLevelDate"}},{"kind":"Field","name":{"kind":"Name","value":"emdrChildLevelDate"}},{"kind":"Field","name":{"kind":"Name","value":"qualifications"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine1"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"regionId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accreditationApplications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accreditationType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"accreditationTypeId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"applicationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"activeAccreditations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"membershipIsExpired"}}]}}]}}]} as unknown as DocumentNode<GetProfileQuery, GetProfileQueryVariables>;
export const GetMembershipDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMembership"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"membership"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"membershipId"}},{"kind":"Field","name":{"kind":"Name","value":"memberId"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionId"}},{"kind":"Field","name":{"kind":"Name","value":"mandateId"}},{"kind":"Field","name":{"kind":"Name","value":"yearlyPrice"}},{"kind":"Field","name":{"kind":"Name","value":"initialPrice"}}]}}]}}]} as unknown as DocumentNode<GetMembershipQuery, GetMembershipQueryVariables>;
export const GetMemberAccreditationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMemberAccreditations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"memberAccreditations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"accreditationType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"accreditationTypeId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"expired"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}}]}}]}}]} as unknown as DocumentNode<GetMemberAccreditationsQuery, GetMemberAccreditationsQueryVariables>;
export const GetDocumentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDocuments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"totalCPD"}},{"kind":"Field","name":{"kind":"Name","value":"totalDueToExpiry"}},{"kind":"Field","name":{"kind":"Name","value":"documents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"cpd"}},{"kind":"Field","name":{"kind":"Name","value":"expiries"}}]}}]}}]}}]} as unknown as DocumentNode<GetDocumentsQuery, GetDocumentsQueryVariables>;
export const GetEventsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEvents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"eventId"}},{"kind":"Field","name":{"kind":"Name","value":"memberId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"href"}},{"kind":"Field","name":{"kind":"Name","value":"postHref"}},{"kind":"Field","name":{"kind":"Name","value":"surveyHref"}},{"kind":"Field","name":{"kind":"Name","value":"documents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"expiryDate"}},{"kind":"Field","name":{"kind":"Name","value":"surveyOpened"}},{"kind":"Field","name":{"kind":"Name","value":"certificateIssued"}},{"kind":"Field","name":{"kind":"Name","value":"memberCertificateIssued"}}]}}]}}]}}]} as unknown as DocumentNode<GetEventsQuery, GetEventsQueryVariables>;
export const GetCpdScoreDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCpdScore"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cpdScore"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generalScore"}},{"kind":"Field","name":{"kind":"Name","value":"caScore"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"percentile"}}]}}]}}]} as unknown as DocumentNode<GetCpdScoreQuery, GetCpdScoreQueryVariables>;